module.exports = {
	"1": [
		[
			"Just you wait",
			"wait for it"
		],
		"Ambition",
		true
	],
	"3": [
		[
			"At your service, sir"
		],
		"Relationship",
		true
	],
	"4": [
		[
			"Talk less, smile more.",
			"Why do you always say what you believe?"
		],
		"Personality",
		true
	],
	"5": [
		[
			"What do you stand for?",
			"If you stand for nothing Burr, what will you fall for?"
		],
		"Personality",
		true
	],
	"6": [
		[
			"Not throwing away my shot"
		],
		"Ambition",
		true
	],
	"7": [
		[
			"Rise up!"
		],
		"Ambition",
		true
	],
	"8": [
		[
			"I imagine death so much if feels more like a memory",
			"If I see it comin’ do I run or do I let it be?",
			"Ask anybody why we livin’ fast...we have to make this moment last",
			"Why do you write like you’re running out of time?"
		],
		"Death",
		true
	],
	"10": [
		[
			"Look around, look around",
			"How lucky we are to be alive right now"
		],
		"Contentment",
		true
	],
	"11": [
		[
			"Right hand man"
		],
		"Relationship",
		true
	],
	"12": [
		[
			"_______ is easy, young man.  _______ is harder"
		],
		"Miscellaneous",
		true
	],
	"13": [
		[
			"Helpless"
		],
		"Personality",
		true
	],
	"14": [
		[
			"Satisfied"
		],
		"Contentment",
		true
	],
	"15": [
		[
			"_______ doesn’t discriminate between the sinners and the saints"
		],
		"Miscellaneous",
		true
	],
	"16": [
		[
			"History has its eyes on you",
			"Who lives, who does, who tells your story?"
		],
		"Legacy",
		true
	],
	"17": [
		[
			"One, two, three, four...ten paces, fire!",
			"Un, deux, troix, quatre…"
		],
		"Miscellaneous",
		true
	],
	"18": [
		[
			"That would be enough",
			"Isn’t this enough?",
			"Would that be enough?",
			"Have I done enough?"
		],
		"Contentment",
		true
	],
	"19": [
		[
			"Narrative",
			"Legacy"
		],
		"Legacy",
		true
	],
	"20": [
		[
			"If we lay a strong enough foundation we’ll pass it on to you",
			"And you’ll blow us all away"
		],
		"Legacy",
		true
	],
	"21": [
		[
			"Room where it happens"
		],
		"Ambition",
		true
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/theme_list.json
 ** module id = 215
 ** module chunks = 0
 **/